<template>
  <v-card ref="DialogContentWarningEditAddressManual">
    <v-card-title class="d-flex">
      <v-icon color="#DF8430" class="mr-2 ml-1" style="font-size: 30px">
        mdi-alert
      </v-icon>
      <h2 class="font-28 dialog-title">Warning</h2>
      <v-btn icon class="btn-close" aria-label="Close" @click="cancel">
        <img src="@/assets/icons/ic_close.svg" />
      </v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <p class="font-20 mb-9">
        Are you sure you want to proceed? Updating the property address will
        cause changes to the existing quote. If you would like a quote for a
        different property, please click ‘Cancel’ and submit a new request.
      </p>
    </v-card-text>
    <v-card-actions class="save-quote-dialog-btn">
      <v-btn
        depressed
        x-large
        rounded
        color="psorange"
        class="proceed-button font-weight-bold font-20 letter-spacing-04 black2-color"
        @click="$emit('toggleAddressFormManually', false)"
        aria-label="Proceed"
        >Proceed</v-btn
      >
      <div class="mt-4 mb-3">
        <a @click="cancel" class="font-20"><u>Cancel</u></a>
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
import { ROUTE_NAME } from "@/constants/route.constants";
export default {
  name: "DialogContentWarningEditAddressManual",
  methods: {
    cancel() {
      this.$emit("cancel");
    },
  },
  computed: {
    isShowSubmitQuoteBtn() {
      return this.$route.name == ROUTE_NAME.LANDLORDS.D2C.QUOTATION_RESULT;
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-contents__wrapper {
  .v-card__title {
    padding: 32px 18px 23px 18px !important;
  }
  .v-card__text {
    padding: 35px 27px 35px 24px !important;
  }
}

.save-quote-dialog-btn {
  padding: 0 90px 21px 90px !important;
  display: flex;
  justify-content: center;
  flex-direction: column;
  .proceed-button {
    min-width: 420px !important;
    height: 60px !important;
  }
}

@media screen and (max-width: $grid-breakpoints-sm) {
  .dialog-contents__wrapper {
    .save-quote-dialog-btn {
      padding: 0 22px 21px 22px !important;
      display: flex;
      justify-content: center;
      flex-direction: column;
      .proceed-button {
        min-width: 0 !important;
        width: 90%;
        height: 60px !important;
      }
    }
  }
}

@media screen and (min-width: $grid-breakpoints-lg) {
  .dialog-contents__wrapper {
    .v-card__title {
      padding: 32px 40px 23px 38px !important;
    }
    .v-card__text {
      padding: 32px 51px 35px 41px !important;
    }
  }
}
</style>
